// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"f9fc14c3","673":"e72fafc9"}[chunkId] + ".chunk.js";
};